
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35 6c-.777 0-1.527.078-2.25.207a1 1 0 00.344 1.973C33.727 8.066 34.359 8 35 8c6.086 0 11 4.914 11 11 0 1.316-.242 2.574-.672 3.754-.133.34-.074.723.156 1.004.235.281.598.414.957.347a.998.998 0 00.766-.668c.504-1.382.793-2.87.793-4.437 0-7.168-5.832-13-13-13zm0 6c-.426 0-.828.043-1.21.11a1.001 1.001 0 00.343 1.972c.293-.05.582-.082.867-.082a4.985 4.985 0 014.691 6.707 1.001 1.001 0 001.883.684c.27-.743.426-1.547.426-2.391 0-3.855-3.145-7-7-7zm-13.824.406c-3.211-.062-8.055 2.473-12.371 6.707C4.512 23.406 2 27.906 2 31.781c0 7.532 9.629 12.032 19.152 12.032 12.348 0 20.614-7.114 20.614-12.766 0-3.453-2.93-5.34-5.547-6.176-.625-.21-1.043-.312-.73-1.152.206-.5.511-1.453.511-2.719 0-1.438-1-2.684-3-2.906-.992-.11-5-.094-7.66 1.02 0 0-1.469.632-1.05-.52.733-2.301.628-4.188-.524-5.235-.625-.629-1.516-.933-2.59-.953zm-.863 11.528c7.804 0 14.128 3.98 14.128 8.894 0 4.91-6.324 8.89-14.129 8.89-7.8 0-14.125-3.98-14.125-8.89 0-4.914 6.325-8.894 14.125-8.894zm-1.047 2.09c-3.02.023-5.953 1.675-7.227 4.222-1.57 3.238-.105 6.797 3.66 7.945 3.766 1.254 8.262-.629 9.832-4.078 1.567-3.343-.418-6.898-4.183-7.836a8.04 8.04 0 00-2.082-.254zm1.558 4.226c.578 0 1.047.465 1.047 1.043a1.047 1.047 0 01-2.094 0c0-.578.47-1.043 1.047-1.043zm-4.406 1.043c.328.004.656.055.965.16 1.34.426 1.75 1.695.926 2.754-.72 1.059-2.364 1.586-3.602 1.059-1.23-.528-1.539-1.801-.82-2.75.539-.797 1.543-1.235 2.531-1.223z"}})])
          )
        }
      }
    